<template>
  <div class="indexBox">
    <div class="indexHeadBox">
      <div class="headTit">凭证查询</div>
      <div class="headContent">
        <div class="textareaBox">
          <el-input
              v-model.trim="value"
              :rows="2"
              placeholder="请输入口令、链接，图片保留3天请及时查看"
              type="textarea"
          >
          </el-input>
        </div>

        <i class="el-icon-search search" @click="search"></i>
      </div>
      <div class="uploadBox">
        <el-upload
            :auto-upload="false"
            :on-change="handleChange"
            :show-file-list="false"
            class="upload"
            drag
        >
          <div
              class="el-upload__text"
              style="color: cadetblue; font-size: 14px; text-align: center"
          >
            🍎。二维码查图 请拖拽图或者点击这里。🍎
          </div>
        </el-upload>
      </div>
    </div>
    <!-- 这是pc端的表格 -->
    <div class="tableBox">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="任务操作" prop="address" width="105">
          <template slot-scope="{row}">
            <button v-if="row.tijiao_number !== '0' && row.status !== '0'"
                    class="el-button el-button--primary el-button--small"
                    type="text"
                    @click="handleClick(row)"
            >
              <span>查看图片</span>
            </button>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" prop="status" width="105">
          <template #default="{ row }">
            <span :style="{color: translationStatusColor(row.status)}">{{ translationStatusStr(row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="完成数量" prop="tijiao_number"></el-table-column>
        <el-table-column label="任务数量" prop="value"></el-table-column>
        <el-table-column label="搜索内容" prop="input" width="180">
        </el-table-column>
        <el-table-column label="下单时间" prop="addtime" width="160">
        </el-table-column>
        <el-table-column label="订单号" prop="orderid" width="140">
        </el-table-column>
      </el-table>
    </div>
    <!-- 这是pc端的表格 -->

    <!-- 这是移动端的表格 -->
    <div class="queryorder-list orderlister">
      <div v-for="(item, index) in tableData" :key="index" class="orderdetail">
        <div class="detail-header">
          <div class="orderlabel">
            <span class="ordertitle">编号: </span>
            <span class="ordernums">{{ item.orderid || '' }}</span>
          </div>
          <div class="statuelabel">
            <span class="statuetile">状态: </span>
            <span :style="{color: translationStatusColor(item.status)}">{{
                translationStatusStr(item.status) || ''
              }}</span>
          </div>
        </div>
        <div class="orderlistdetail">
          <div class="detail-lister">
            <div class="titles">下单时间</div>
            <div class="orderscontener">{{ item.addtime || '' }}</div>
          </div>
          <div class="detail-lister">
            <div class="titles">链接口令</div>
            <div class="orderscontener">
              <el-input v-model="item.input" type="text"/>
            </div>
          </div>
          <div class="detail-lister">
            <div class="titles">数量</div>
            <div class="orderscontener">{{ item.value || '' }}</div>
          </div>
          <div class="detail-lister">
            <div class="titles">已完成</div>
            <div class="orderscontener">{{ item.tijiao_number || '' }}</div>
          </div>
          <div class="detail-lister">
            <div class="titles">操作</div>
            <div class="orderscontener editors">
              <el-button v-if="item.tijiao_number !== '0' && item.status !== '0'"
                         class="el-button el-button--success el-button--mini"
                         style="width: 30% !important; padding: 7px 9px !important;"
                         type="button" @click="handlePreview(item.query_url)">
                <span>查看截图</span>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 这是移动端的表格 -->

    <div class="tipBox">
      <span class="tipTit">查询不到数据一般有几种情况:</span>
      <el-divider></el-divider>
      <ul>
        <li>
          1. 查询口令：
          <span class="red">👏KB5P8l👱jcbKvO9📻，</span>
          去掉表情，保留部分字符即可，如：jcbKvO9
        </li>
        <li>2. 【https://dwz.cn/QKdQHd0y】这类链接使用完整信息查图</li>
        <li>
          3. 【<span class="red">7445635896738</span>
          事业有成】这类口令使用标红的部分查图
        </li>
        <li>
          4. 查询口令：
          <span class="red"
          >🗻🍹感激涕零🠵喜笑颜开👍
            十二年才能盼到一个吉祥的喜新年，高兴无比。新年有着吉祥好运发财安康的含义，人心所向。为达到新年废寝忘食努力奋斗打拼，追求美好。愿你新年，开羊荤喝洋酒享羊福!</span
          >
          ，去掉后面多余的文字，保留部表情符号中文字符即可，如：<span
            class="red"
        >🗻🍹感激涕零🠵喜笑颜开👍</span
        >
        </li>
        <li>5.查询不到的请联系客服查询！</li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {Message, Loading} from "element-ui";

export default {
  data() {
    return {
      value: "",
      tableData: [],
    };
  },
  mounted() {
    console.log("url = ", this.$route.query.url);
    let url = this.$route.query.url;
    if (url) {
      this.value = url;
      this.search();
    }
    let pddurl = this.getPddUrl()
    if (pddurl) {
      this.value = pddurl;
      this.search();
    }
  },
  methods: {
    handleChange(eleFile) {
      let that = this;
      let file = eleFile.raw;
      new Promise(function (ok, no) {
        if (window.URL && window.URL.createObjectURL) {
          ok(window.URL.createObjectURL(file));
        } else if (typeof FileReader) {
          var reader = new FileReader();
          reader.onload = (evt) => {
            ok(evt.target.result);
          };
          reader.readAsDataURL(file);
        } else {
          Message.error("浏览器不支持");
        }
      }).then((src) => {
        qrDecode.decodeByUrl(src, function (err, txt) {
          if (err) {
            console.log(err);
            Message.error(
                "抱歉，二维码不支持，请用链接或口令查询！"
            );
          } else {
            Message({
              type: "success",
              showClose: true,
              message: "识别成功！",
            });
            that.value = txt;
          }
        });
      });
    },
    // 查看详情
    handleClick(row) {
      window.open(row.query_url)
      // window.location.href = row.query_url
      // if (item.type == "拼多多红包") {
      //   this.$router.push({
      //     path: "/detail",
      //     query: {
      //       id: item.danhao,
      //     },
      //   });
      // } else {
      //   if (item.type == "拼多多低价单") {
      //     this.$router.push({
      //       path: "/detail",
      //       query: {
      //         id: item.danhao,
      //       },
      //     });
      //   } else {
      //     this.$router.push({
      //       path: "/videoDetail",
      //       query: {
      //         id: item.danhao,
      //       },
      //     });
      //   }
      // }
    },

    search() {
      if (!this.value) {
        Message({
          type: "error",
          showClose: true,
          message: "请输入搜索内容！",
        });
        return;
      }
      this.loading = Loading.service({
        fullscreen: true,
        text: "数据加载中...",
      });
      let data = new FormData();
      data.append("kw", this.value);
      data.append("page", 1);
      data.append("pagesize", 50);
      axios
          .post("https://user.xn--nfv429h.net/ajax_api.php?act=order_query", data, {
            timeout: 50000000000,
          })
          .then((res) => {
            this.loading.close();
            if (res.data.data == false) {
              Message({
                type: "warning",
                showClose: true,
                message: "未查询到数据！",
              });
              return;
            }
            res.data.data.forEach((element) => {
              element.ssnr = this.value;
            });
            this.tableData = res.data.data;
            Message({
              type: "success",
              showClose: true,
              message: "查询成功！",
            });
          })
          .catch(() => {
            this.loading.close();
          });
    },

    handlePreview(url) {
      window.location.href = url
    },

    translationStatusStr(val) {
      const statusObj = {
        1: '已完成',
        2: '正在处理',
        3: '异常',
        4: '已退单',
        5: '待处理'
      }
      return statusObj[val]
    },

    translationStatusColor(val) {
      const statusObj = {
        1: '#008000',
        2: '#f5d925',
        3: '#ff0000',
        4: '#ff0000',
        5: '#3d77f5'
      }
      return statusObj[val]
    },

    getQueryVariable(variable, url) {
      try {
        var pddurl = url.split("?")[1];
        var query = pddurl.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return (false);
      } catch (e) {
        return (false);
      }
    },

    getPddUrl() {
      var pddurl = window.location.hash.replace('#/', '');
      var oldpddurl = ''
      if (pddurl) {
        pddurl = pddurl.replace("?pddurl=", "")
        oldpddurl = pddurl
      }
      if (pddurl.indexOf('invite_code') > -1) {
        pddurl = this.getQueryVariable('invite_code', pddurl);
        if (!pddurl) {
          pddurl = oldpddurl
        }
      }
      if (pddurl) {
        return decodeURIComponent(pddurl)
      } else {
        return false
      }
    }
  },

  destroyed() {
  },
};
</script>

<style scoped>
@import url("./index.css");

a {
  color: red;
}
</style>
